import * as React from "react";

const TAB_START_BREAKPOINT = 768;
const TAB_END_BREAKPOINT = 1024;

export function useIsTab() {
    const [isTab, setIsTab] = React.useState<boolean>(false);

    React.useEffect(() => {
        const checkIsTab = () => {
            setIsTab(window.innerWidth >= TAB_START_BREAKPOINT && window.innerWidth < TAB_END_BREAKPOINT);
        };
        checkIsTab();
        window.addEventListener("resize", checkIsTab);
        return () => window.removeEventListener("resize", checkIsTab);
    }, []);

    return isTab;
}
